import { render, staticRenderFns } from "./PublicLearningNavigation.vue?vue&type=template&id=0b368f21"
import script from "./PublicLearningNavigation.vue?vue&type=script&lang=js"
export * from "./PublicLearningNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PublicLearningNavigation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports